export default __webpack_public_path__ + "static/media/safe-recommendations--tablet.0c2409dd.jpg";